import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=9aa244ee&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa244ee",
  null
  
)

export default component.exports